module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/preauth-479b7447e750de809e51c6022c6c86d2.svg";